import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import HeaderCustom from '../components/HeaderCustom.vue';
import CardParametrosConsulta from './components/CardParametrosConsulta.vue';
import ResultadoConsulta from './components/ResultadoConsulta.vue';
import { usePublicoParecerReferencialStore } from './store/PublicoParecerReferencialStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicoParecerReferencial',
  setup(__props) {

const store = usePublicoParecerReferencialStore();

const { result } = storeToRefs(store);

return { __sfc: true,store, result, HeaderCustom, CardParametrosConsulta, ResultadoConsulta }
}

})